import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Package, ShoppingBag, Clock, DollarSign } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await axios.get(`${API}/admin/stats`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(response.data);
    } catch (error) {
      if (error.response?.status === 401) {
        navigate('/admin/login');
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="p-8">Loading...</div>;
  }

  return (
    <div>
      <h1 className="text-3xl font-light text-neutral-900 mb-8">Dashboard</h1>
      
      <div className="grid md:grid-cols-4 gap-6 mb-8">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-light text-neutral-600">Total Products</CardTitle>
            <Package className="w-4 h-4 text-neutral-400" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-light">{stats?.total_products || 0}</div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-light text-neutral-600">Total Orders</CardTitle>
            <ShoppingBag className="w-4 h-4 text-neutral-400" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-light">{stats?.total_orders || 0}</div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-light text-neutral-600">Pending Orders</CardTitle>
            <Clock className="w-4 h-4 text-neutral-400" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-light">{stats?.pending_orders || 0}</div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-light text-neutral-600">Total Revenue</CardTitle>
            <DollarSign className="w-4 h-4 text-neutral-400" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-light">£{stats?.total_revenue?.toFixed(2) || '0.00'}</div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="font-light">Welcome to Freddy & Co. Admin</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-neutral-600 mb-4">
            Manage your products, orders, and store settings from this dashboard.
          </p>
          <div className="space-y-2 text-sm text-neutral-600">
            <p>• Use <strong>Products</strong> to add Freddy's photos and manage inventory</p>
            <p>• View and process customer <strong>Orders</strong></p>
            <p>• Configure Stripe keys in <strong>Settings</strong></p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Dashboard;